import { VisibilitySwitches } from "src/hooks/contentFilters/switch/useShouldShowSwitches";
import { AllSwitchFilterNames, SwitchConfigInterface } from "./switchTypes";

export const getSwitchesConfig = ({visibilitySwitches, onExtraChange}:{
  visibilitySwitches: VisibilitySwitches,
  onExtraChange: ()=>void
  }): SwitchConfigInterface[] => [
    {
          name: AllSwitchFilterNames.MFWOriginals,
          condition: visibilitySwitches.showMFWOriginalsSwitch,
          iconColor: "primary",
          switchColor: "primary",
          switchType: "multi",
          column: 1,
        },
        {
          name: AllSwitchFilterNames.OrgOriginals,
          condition: visibilitySwitches.showOrgOriginalsSwitch,
          iconColor: "secondary",
          switchColor: "primary",
          switchType: "multi",
          column: 1,
        },
        {
          name: AllSwitchFilterNames.PremiumContent,
          condition: visibilitySwitches.showPremiumSwitch,
          iconColor: "secondary",
          switchColor: "secondary",
          switchType: "one_only",
          column: 1,
        },
        {
          name: AllSwitchFilterNames.NetContent,
          condition: visibilitySwitches.showPublicSwitch,
          iconColor: "secondary",
          switchColor: "secondary",
          switchType: "one_only",
          onExtraChange: onExtraChange,
          column: 1,
        },
        {
          name: AllSwitchFilterNames.MarketplaceContent,
          condition: visibilitySwitches.showLockedContentSwitch,
          iconColor: "secondary",
          switchColor: "secondary",
          switchType: "one_only",
          column: 2,
        },
        {
          name: AllSwitchFilterNames.MyNetContent,
          condition: visibilitySwitches.showMyNetSwitch,
          iconColor: "secondary",
          switchColor: "secondary",
          switchType: "one_only",
          column: 2,
        },
];